import { ampli } from "../ampli";
import {
  ReactEnvironments,
  AMPLI_ENV_PROD,
  AMPLI_ENV_DEV,
  AMPLI_KEYS,
} from "../pages/common/constants";

export const initializeAmplitude = (environment: string): void => {
  const isProduction = environment === ReactEnvironments.Production;

  ampli.load({
    environment: isProduction ? AMPLI_ENV_PROD : AMPLI_ENV_DEV,
    client: {
      apiKey: AMPLI_KEYS[ReactEnvironments.Develop],
    },
  });
};

export const loadAmpli = (loginId: string): void => {
  ampli.identify(loginId);
  ampli.openCdcmPortal({
    "Referring Domain": "OKTA",
    "Start Session": String(new Date()),
  });
};
